import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ApiOauthService, ApiWpService, MareAuthService } from "@mare-common/ngx-mare-auth";
import { ErrorHandlerService, EventInteractionService } from "@mare-common/ngx-mare-common";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class PlatformApiWpService extends ApiOauthService {
    origin!: any;
    
    constructor(
        http: HttpClient, 
        errorHandler: ErrorHandlerService, 
        sanitizer: DomSanitizer, 
        authService: MareAuthService,
        eventInteractionService: EventInteractionService,
    ) {
      super(http, errorHandler, sanitizer, authService, eventInteractionService);
      let url!: string;
      const env: any = environment;
      if(this.isCurrentUrlLocalhost() || (env.forceServiceEndpoint && env.forceServiceEndpoint === true)) {
        url = environment.serviceEndpoint;
      } else {
        url = this.extractBaseUrl() + '/wp-json';
      }
      this.setEnvironment(url, undefined, undefined);
      this.getOrigin();
    }

    isCurrentUrlLocalhost() {
      return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    }

    extractBaseUrl() {
      return window.location.protocol + '//' + window.location.hostname;
    }

    getOrigin(): string {
      if(this.origin)
        return this.origin;
      let url!: any;
      const env: any = environment;
      if(this.isCurrentUrlLocalhost() || (env.forceServiceEndpoint && env.forceServiceEndpoint === true)) {
        url = new URL(environment.serviceEndpoint);
        url = url.origin;
      } else {
        url = this.extractBaseUrl();
      }
      this.origin = url;
      return url;
    }
    

  }
